import { render, staticRenderFns } from "./CreateDepartmentModal.vue?vue&type=template&id=39d5db69&"
import script from "./CreateDepartmentModal.vue?vue&type=script&lang=js&"
export * from "./CreateDepartmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports